/**
 * Travo's store and community links
 */

export const DOWNLOAD_LINKS = {
  appStore: 'https://apps.apple.com/us/app/travo/id6755287883',
  appStoreTW: 'https://apps.apple.com/tw/app/travo/id6755287883',
  appStoreJP: 'https://apps.apple.com/jp/app/travo/id6755287883',
  appStoreKR: 'https://apps.apple.com/kr/app/travo/id6755287883',
  appStoreTH: 'https://apps.apple.com/th/app/travo/id6755287883',
  playStore: 'https://play.google.com/store/apps/details?id=com.travolabs.travo'
} as const;

export const COMMUNITY_LINKS = {
  telegram: 'https://t.me/travo_app',
  productHunt: 'https://www.producthunt.com/products/travo-3'
} as const;
